import { render, staticRenderFns } from "./SmsTemplateItem.vue?vue&type=template&id=238d4c82&"
import script from "./SmsTemplateItem.vue?vue&type=script&lang=ts&"
export * from "./SmsTemplateItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports